import { api } from "../../../services/api/api";

const defaultConfig = {
    headers: {
        'Content-Type': 'application/json'
    }
};
async function fetchUpsellPanelData(url, params = null) {
    try {
        const response = await api.get(`/miniaccounts${url}`, params);
        return response.data;
    } catch (error) {
        throw error;
    }
}
async function postUpsellPanelData(url, data = null, config = defaultConfig) {
    try {
        const response = await api.post(`/miniaccounts${url}`, data, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function loginUser(model) {
    return await postUpsellPanelData("/newlogin", JSON.stringify(model));
}
export async function mfaLogin(model) {
    return await postUpsellPanelData("/mfa", JSON.stringify(model));
}
export async function updateSubscriberPhoneNumber(mobile) {
    return await postUpsellPanelData("/updateSubscriberPhoneNumber", mobile);
}
export async function resendSmsToken(mobile) {
    return await postUpsellPanelData("/resendSmsToken", { mobile });
}
export async function verifySMSToken(model) {
    return await postUpsellPanelData("/verifySMSToken", model);
}
export async function requestMFAToken(email) {
    return await fetchUpsellPanelData(`/mfa-token?email=${email}`);
}
export async function createUser(model) {
    return await postUpsellPanelData("/newsignup", JSON.stringify(model));
}
export async function activateTrial(model) {
    return await postUpsellPanelData("/activatePlusTrial", JSON.stringify(model));
}
export async function forgotPassword(model) {
    return await postUpsellPanelData("/forgotPassword", JSON.stringify(model));
}
export async function checkForExistingUser(email) {
    const response = await api.get(`/api/subscriber?email=${email}`);
    return response.data;
}
export async function hasTakenTrial(requiredAccessLevel) {
    return await fetchUpsellPanelData(`/hasTakenTrial?requiredAccessLevel=${requiredAccessLevel}`);
}